import { ChangeDetectorRef, Component, HostListener, Inject } from '@angular/core';
import { TopEntitiesChartComponent } from './top-entities-chart.component';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { OutletsPublicApi } from '../../../../api/targeting/outlets-public.api';
import { ContactsPublicApi } from '../../../../api/targeting/contacts-public.api';
import { JournodexEntityFactory } from '../../../../Discover/Targeting/factories/journodex-entity.factory';
import { ProfileTakeOverInterface } from '../../../../Common/TargetingShared/interfaces/profile-take-over.interface';
import { ReportsDrillDownInterface } from '../../../../Common/Reports/interfaces/reports-drill-down.interface';
import { APP_BASE_HREF } from '@angular/common';


@Component({
    selector: 'agpr-top-entities-drill-down-chart',
    templateUrl: './top-entities-chart.component.html',
    styleUrls: ['./top-entities-chart.component.scss'],
    standalone: false
})
export class TopEntitiesDrillDownChartComponent extends TopEntitiesChartComponent {

    constructor(
        public localizationService: LocalizationService,
        public outletsPublicApi: OutletsPublicApi,
        public contactsPublicApi: ContactsPublicApi,
        public journodexEntityFactory: JournodexEntityFactory,
        public cd: ChangeDetectorRef,
        @Inject('ProfileTakeOverInterface') public targetingRhpDialogService: ProfileTakeOverInterface,
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        @Inject('ReportsDrillDownInterface') public reportsChartDetailService: ReportsDrillDownInterface
    ) {
        super(
            localizationService,
            outletsPublicApi,
            contactsPublicApi,
            journodexEntityFactory,
            cd,
            targetingRhpDialogService,
            appBaseHref
        );
    }

    @HostListener('click', ['$event.target']) onClick(event) {
        if (event?.classList?.contains('viewMentionLink')) {
            this.reportsChartDetailService.viewCoverageAnalysisDialog(event.href, null, this.chart.clone(), true);
            return false;
        }
    }
}
